import { render, staticRenderFns } from "./StandardButton.vue?vue&type=template&id=2e21a207&"
import script from "./standardButton.js?vue&type=script&lang=js&"
export * from "./standardButton.js?vue&type=script&lang=js&"
import style0 from "./StandardButton.vue?vue&type=style&index=0&id=2e21a207&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports